import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/packagesSalesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const selectedRangeOption = useSelector((state) => state.packagesSales.selectedRangeOption);
  const rangeOptions = useSelector((state) => state.packagesSales.rangeOptions);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};

export default CustomDateRanges;
